export default {
  DATE: 1,
  MONTH: 2,
  DAY: 3,
  HOUR: 4,
  ORDER_HOUR: 5,
}



// WEBPACK FOOTER //
// ./src/consts/reportAggregateMethods.js